import type { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'

import calculateGraphqlContracts from 'modules/contracts/lib/calculateGraphqlContracts'
import type GraphqlContract from 'modules/contracts/lib/graphqlContract'

interface EmployeeGraphqlContracts {
  contracts: GraphqlContract[]
  selectedContract?: GraphqlContract
  nextContract?: GraphqlContract
  previousContract?: GraphqlContract
}

const useGraphqlContracts = (
  selectedGraphqlContractVersion: ContractVersionPageContractVersionFragment,
  graphqlContractVersions: ContractVersionPageContractVersionFragment[]
): EmployeeGraphqlContracts => {
  const contractsKey = graphqlContractVersions
    .map((version) => `${version.id}-${version.effectiveOn}-${version.endsOn || 'null'}`)
    .join('|')

  const contracts = useMemo(() => {
    return calculateGraphqlContracts(graphqlContractVersions)
  }, [contractsKey])

  const selectedContractIndex = contracts.findIndex((contract) =>
    contract.includesVersion(selectedGraphqlContractVersion)
  )
  const selectedContract = contracts[selectedContractIndex]
  const nextContract = contracts[selectedContractIndex - 1]
  const previousContract = contracts[selectedContractIndex + 1]

  return { contracts, selectedContract, nextContract, previousContract }
}

export default useGraphqlContracts
